//------------------------------------------------------ externos
import { useState } from "react";
//------------------------------------------------------ elementos
import CardLogo from "../../components/cards/CardLogo";
import Modal from "../modales/Modal";
//------------------------------------------------------ funciones
import { columnas } from "../../components/modales/data/Columnas";
import { capitalizarTexto } from "../../functions/dataFunctions";
import { cacheStore } from "../../services/cache";
import { useRealtime } from "../../services/store";

/* `titulo` cambia sólo lo que se lee: la tarjeta y el encabezado del listado.
 * La colección, la ficha y el realtime siguen colgando de `col`. Existe por el
 * 20/10: el padrón de proveedores se llama «Talleres y servicios» en el Pañol
 * (Depósitos lo pasa), y en Portería sigue «Proveedores», porque ahí el camino
 * «Un proveedor» elige la empresa de esa misma lista. */
const EmpresasAccess = ({ col = "empresas", titulo = null }) => {
  const TITLE = titulo || capitalizarTexto(col);
  const COLECCION = col;
  const [modalVisible, setModalVisible] = useState(false);
  const headers = columnas[COLECCION];

  // "proveedores" viene del store realtime (Firestore en vivo).
  // cualquier otro "col" (hoy no se usa en la app) cae al cache estatico.
  const listadoRealtime = useRealtime(
    col === "proveedores" ? "proveedores" : "__sin_uso__",
  );
  const listado =
    col === "proveedores"
      ? listadoRealtime
      : cacheStore[COLECCION]?.data || [];

  return (
    <>
      <CardLogo
        icono="proveedor"
        title={TITLE}
        onClick={() => setModalVisible(true)}
        onClose={() => setModalVisible(false)}
      />

      {modalVisible && headers.length > 0 && (
        <Modal
          title={TITLE}
          coleccion={COLECCION}
          data={listado}
          headers={headers}
          onClose={() => setModalVisible(false)}
        />
      )}
    </>
  );
};

export default EmpresasAccess;
